<template>
  <div>
    <div class="search-select px-5">
      <img
        class="search-select__shadow"
        :src="require('@/assets/images/select-shadow.png')"
        alt=""
      />
      <v-select
        class="centered-input"
        placeholder="اختر الشهر"
        dense
        ref="select"
        height="70px"
        :hide-details="true"
        background-color="#209764"
        item-value="value"
        item-text="title"
        v-model="monthValue"
        :items="months"
        @change="$emit('change', $event)"
      >
        <template v-slot:append>
          <img
            class="search-select__arrow cursor-pointer"
            :src="require('@/assets/images/arrow-down.png')"
          />
        </template>
      </v-select>
    </div>
    <div class="d-flex align-center justify-space-around">
      <img
        class="cover-left"
        width="180px"
        :src="require(`@/assets/images/fruits/${selectedFruit.photo}`)"
        alt=""
      />
      <span class="img-title cover-right">{{ selectedFruit.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedFruit: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    months: [
      {
        title: "يناير",
        value: "January",
      },
      {
        title: "فبراير",
        value: "February",
      },
      {
        title: "مارس",
        value: "March",
      },
      {
        title: "ابريل",
        value: "April",
      },
      {
        title: "مايو",
        value: "May",
      },
      {
        title: "يونيو",
        value: "June",
      },
      {
        title: "يوليو",
        value: "July",
      },
      {
        title: "أغسطس",
        value: "August",
      },
      {
        title: "سبتمبر",
        value: "September",
      },
      {
        title: "أكتوبر",
        value: "October",
      },
      {
        title: "نوفمبر",
        value: "November",
      },
      {
        title: "ديسمبر",
        value: "December",
      },
    ],
    monthValue: "",
  }),
  methods: {
    handleSelect() {
      this.$refs.select.click;
    },
  },
  created() {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    this.monthValue = monthNames[d.getMonth()];
  },
};
</script>

<style lang="scss">
.search-select {
  position: relative;
  .img-title {
    font-size: 40px;
    font-weight: bold;
    color: #29a671;
  }

  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 40px;
    z-index: 1;
  }
  .v-input {
    border-radius: 6px;
    input {
      text-align: center;
      font-weight: 600;
      font-size: 32px;
      color: white;
    }
  }
  .v-input__slot {
    &::after,
    &::before {
      display: none;
    }
  }
  &__shadow {
    position: absolute;
    bottom: -25px;
    left: 0px;
    height: 50px;
    width: 100%;
    opacity: 0.7;
  }
}
.v-menu__content {
  &::-webkit-scrollbar {
    width: 7px;
    height: 200px;
    background: rgb(231, 231, 231);
  }
  &::-webkit-scrollbar-thumb {
    background: rgb(173, 173, 173);
    border-radius: 10px;
  }
}
.v-list {
  background: #209764 !important;
  .v-list-item__content {
    text-align: center !important;
    color: white !important;
    min-height: 48px;
    .v-list-item__title {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    div {
      font-size: 22px !important;
    }
  }
  .v-list-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.178);
    position: relative;
    z-index: 9999999999;
    background: rgba($primary,0.9);
  }
}
.v-select__selection {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  height: 50px;
  margin-bottom: 14px !important;
}
.v-text-field input::placeholder {
  color: rgb(230, 230, 230) !important;
}
.cover-left {
  animation: coverLeft 1s forwards;
}

.cover-right {
  animation: coverRight 1s forwards;
}

@keyframes coverLeft {
  0% {
    opacity: 0;
    transform: translateX(-30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes coverRight {
  0% {
    opacity: 0;
    transform: translateX(30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}
</style>
